import Vue from 'vue'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import TextInput from '../../component/dccore-form/textInput.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import Checkbox from '../../component/dccore-form/checkbox.vue'
import DatePicker from '../../component/dccore-form/datePicker.vue'
import BagOrderIds from './bagOrderIds.vue'
import History from './history.vue'
import toastr from '../toastr'

if ($('#diet_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#diet_form',
    components: {
      RingLoader,
      Multiselect,
      TextInput,
      NumberInput,
      Singleselect,
      Checkbox,
      DatePicker,
      BagOrderIds,
      History
    },
    mixins: [mixins],
    data: {
      loading: 1,
      entityId: null,
      form: {
        entity: {
          user: null,
          order: null,
          priceBeforeDiscount: 0,
          priceDiscount: 0,
          updatedAt: null,
        },
        selected: {},
        errors: {}
      },
      priceDiscountDisplay: '',
      ordersDisplay: '',
      packages: [],
      variants: [],
      baskets: [],
      orders: [],
      firstLoadFinished: false,
    },
    watch: {
      'form.entity.priceBeforeDiscount': function () {
        this.calcDiscount()
      },
      'form.entity.priceDiscount': function () {
        this.calcDiscount()
      },
      'form.entity.package': function (newPackage) {
        if (!isNaN(parseInt(newPackage))) {
          this.getVariants()
        }
      },
      'form.entity.defaultVariant': function (newVariant) {
        if (!isNaN(parseInt(newVariant))) {
          this.getBaskets()
        }
      },
      'loading': function (newValue) {
        if (newValue === 0 && this.firstLoadFinished === false) {
          this.firstLoadFinished = true
          if (this.entityId === null) {
            this.setDefaults()
          }
        }
      }
    },
    mounted: function () {
      this.getPackages()
      if ($('#entity_id').length) {
        this.entityId = $('#entity_id').val()
        this.getDiet()
      }

      this.loading--

    },
    methods: {
      createDiet(redirect) {
        if (this.entityId) {
          this.updateDiet(redirect)
          return
        }

        this.loading++
        let url = Routing.generate('api_post_diet')
        let data = { data: this.form.entity }

        this.$http.post(url, data).then(response => {
          if (redirect) {
            $(location).attr('href', Routing.generate('diet_grid'))
          } else {
            toastr.success(Translator.trans('form.created'))
            this.form.errors = {}
            this.entityId = response.data.id
          }
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form)
        })
      },
      updateDiet(redirect) {
        this.loading++
        let url = Routing.generate('api_patch_diet', {
          id: this.entityId,
        })
        let data = { data: this.form.entity }

        this.$http.patch(url, data).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('diet_grid'))
          } else {
            toastr.success(Translator.trans('form.updated'))
            this.form.errors = {}
            this.getDiet()
          }
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form)
        })
      },
      getDiet() {
        this.loading++
        let url = Routing.generate('api_get_diet', { id: this.entityId,
          context: 'edit' })

        this.$http.get(url).then(response => {
          this.form.entity = response.data

          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getPackages() {
        this.loading++
        let url = Routing.generate('api_get_packages', { context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.packages = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getVariants() {
        this.loading++
        let url = Routing.generate('api_get_package_variants', {
          context: 'list',
          id: this.form.entity.package
        })

        Vue.http.get(url).then(response => {
          this.variants = response.data

          let variantExist = false
          let i

          for (i = 0; i < this.variants.length; i++) {
            if (String(this.form.entity.defaultVariant) === String(this.variants[i].id)) {
              variantExist = true
              break
            }
          }

          if (!variantExist) {
            this.form.entity.defaultBasket = null
            this.form.entity.defaultVariant = null
          }

          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getBaskets() {
        this.loading++
        let url = Routing.generate('api_get_variant_baskets', {
          context: 'list',
          id: this.form.entity.defaultVariant
        })

        Vue.http.get(url).then(response => {
          this.baskets = response.data

          let basketExist = false
          let i

          for (i = 0; i < this.baskets.length; i++) {
            if (String(this.form.entity.defaultBasket) === String(this.baskets[i].id)) {
              basketExist = true
              break
            }
          }

          if (!basketExist) {
            this.form.entity.defaultBasket = null
          }

          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getOrders() {
        this.loading++
        let url = Routing.generate('api_get_client_orders', { id: this.form.entity.user,
          context: 'list' })

        Vue.http.get(url).then(response => {
          this.orders = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      calcDiscount() {
        let percent = Math.round((this.form.entity.priceDiscount / this.form.entity.priceBeforeDiscount) * 100 * 100) / 100

        if (!isNaN(percent)) {
          this.priceDiscountDisplay = `${this.dcNumberFormat(this.form.entity.priceDiscount)} (${this.dcNumberFormat(percent)}%)`
        } else {
          this.priceDiscountDisplay = 0
        }
      },
      setDefaults() {
        let defaultData = this.parseURLParams(window.location.href)

        if (typeof defaultData === 'undefined') {
          return
        }

        if (typeof defaultData.user !== 'undefined') {
          this.form.entity.user = defaultData.user[0]
        }

        if (typeof defaultData.order !== 'undefined') {
          this.form.entity.order = defaultData.order[0]
        }
      }
    }
  })
}
